import React from 'react';
import { FadeIn } from './FadeIn';
import { MessageCircleOff, Clock, Smartphone } from 'lucide-react';
export function PainSection() {
  return <section className="pt-16 pb-8 md:pt-32 md:pb-12 relative bg-deep-black" data-id="element-181">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-champagne-gold/50 to-transparent" data-id="element-182"></div>
      <div className="absolute top-1/4 -left-64 w-96 h-96 bg-burgundy/20 rounded-full blur-[120px]" data-id="element-183"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-184">
        <FadeIn data-id="element-185">
          <h2 className="font-playfair text-3xl md:text-5xl text-center mb-10 md:mb-16 text-cream leading-tight" data-id="element-186">
            Tu as un match incroyable.
            <br data-id="element-187" />
            La conversation pétille.
            <br data-id="element-188" />
            <span className="text-champagne-gold italic" data-id="element-189">Et soudain…</span>
          </h2>
        </FadeIn>

        <div className="grid gap-5 md:gap-8 md:grid-cols-3 mb-12 md:mb-20" data-id="element-190">
          <FadeIn delay={0.2} className="bg-glass-burgundy backdrop-blur-md border border-burgundy/30 rounded-3xl p-8 text-center" data-id="element-191">
            <MessageCircleOff className="w-10 h-10 text-champagne-gold mx-auto mb-6 opacity-80" data-id="element-192" />
            <h3 className="font-playfair text-xl mb-4 text-cream" data-id="element-193">
              Le Silence
            </h3>
            <p className="text-muted-cream text-sm leading-relaxed font-light" data-id="element-194">
              Il voit tes messages. Il ne répond pas. Tu fixes l'écran en
              attendant une notification qui ne vient pas.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} className="bg-glass-burgundy backdrop-blur-md border border-burgundy/30 rounded-3xl p-8 text-center" data-id="element-195">
            <Clock className="w-10 h-10 text-champagne-gold mx-auto mb-6 opacity-80" data-id="element-196" />
            <h3 className="font-playfair text-xl mb-4 text-cream" data-id="element-197">
              Le Retour Facile
            </h3>
            <p className="text-muted-cream text-sm leading-relaxed font-light" data-id="element-198">
              Il revient trois jours plus tard avec un "Coucou ça va ?" comme si
              de rien n'était. Tu mérites mieux.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} className="bg-glass-burgundy backdrop-blur-md border border-burgundy/30 rounded-3xl p-8 text-center" data-id="element-199">
            <Smartphone className="w-10 h-10 text-champagne-gold mx-auto mb-6 opacity-80" data-id="element-200" />
            <h3 className="font-playfair text-xl mb-4 text-cream" data-id="element-201">
              L'Épuisement
            </h3>
            <p className="text-muted-cream text-sm leading-relaxed font-light" data-id="element-202">
              Être patiente. Être drôle. Être disponible. Tu as tout essayé,
              mais le résultat reste le même.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}